import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import WizardStart from "components/Wizard/WizardStart";

import * as blueprintReducer from "containers/Blueprint/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";

class WizardStartContainer extends React.PureComponent {
  render() {
    const { id, blueprintId } = this.props;

    return <WizardStart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateModelType: (type) => dispatch(wizardReducer.updateModelType(ownProps.id, ownProps.blueprintId, type)),
    updateAibleMode: (mode) => dispatch(wizardReducer.updateAibleMode(ownProps.id, ownProps.blueprintId, mode))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    modelType: wizardReducer.getModelType(state, ownProps.id, ownProps.blueprintId),
    aibleMode: wizardReducer.getAibleMode(state),

    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),

    isEditBlueprint:
      (ownProps.id === "new" && ownProps.blueprintId === "new") ||
      blueprintReducer.getIsEditing(state, ownProps.blueprintId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(WizardStartContainer);
